<template>
  <div class="content">
    <div class="p">How to troubleshoot a CT that is not reading</div>

    <div class="p">
      Each CT must be
      <ul class="p">
        <li>Clipped around the correct cable</li>
        <li>Clipped in the correct orientation</li>
        <li>Correctly fitted to the SolShare connector</li>
        <li>If extended CT, good electrical contact at extension point</li>
      </ul>
    </div>

    <div class="p" data-tn="ct-error-list">
      Connection to check:
      <ul class="p">
        <li v-for="(unit, i) in CTNotReadingUnits" :key="i">{{ unit }}</li>
      </ul>
    </div>

    <back-and-next
      next-text="Next - CT Installation"
      to="/commission/error/ct-not-reading-uk/2"
      data-tn="ct-not-reading-uk/1"
    >
    </back-and-next>
  </div>
</template>

<script>
import { CommissionErrorMixin } from "../../../../../mixins/commissionError";

export default {
  mixins: [CommissionErrorMixin],
};
</script>

<style scoped lang="less">
.content {
  .p {
    margin-top: 20px;
  }
}
</style>
